<template>
  <tw-container class="mt-4">
    <div>
      <tw-card class="bg-blue-100" icon="question-circle">
        <h2>  Other Support methods</h2>
        <p>You can also contact via email at <a class="font-weight-bold" href="mailto:help@grouprev.com">help@grouprev.com</a></p>
        <p>Or via phone number: Phone: <a href="tel:800-454-1264">800-123-4567</a> </p>
      </tw-card>
      <div class="clearfix" />
      <tw-dropdown variant="primary" class="float-right mt-5">
        <template #button>
          Filter by: <tw-badge variant="blue" class="px-4">
            {{ $filters.formatString(status) }}
          </tw-badge>
        </template>
        <tw-dropdown-item :to="{ name: 'support-requests-index-page-by-status', params: { status: 'all' }}">
          <icon v-if="status === 'all'" icon="check" /> All
        </tw-dropdown-item>
        <tw-dropdown-item :to="{ name: 'support-requests-index-page' }">
          <icon v-if="status === 'all-currently-open'" icon="check" /> All Currently Open
        </tw-dropdown-item>
        <tw-dropdown-item :to="{ name: 'support-requests-index-page-by-status', params: { status: 'pending' } }">
          <icon v-if="status === 'pending'" icon="check" /> Pending
        </tw-dropdown-item>
        <tw-dropdown-item :to="{ name: 'support-requests-index-page-by-status', params: { status: 'in_progress' } }">
          <icon v-if="status === 'in_progress'" icon="check" /> In Progress
        </tw-dropdown-item>
        <tw-dropdown-item :to="{ name: 'support-requests-index-page-by-status', params: { status: 'closed' } }">
          <icon v-if="status === 'closed'" icon="check" /> Closed
        </tw-dropdown-item>
        <tw-dropdown-item :to="{ name: 'support-requests-index-page-by-status', params: { status: 'discarded' } }">
          <icon v-if="status === 'discarded'" icon="check" /> Discarded
        </tw-dropdown-item>
      </tw-dropdown>
      <h2 class="mt-4">
        Support Requests <strong>{{ $filters.formatString(status) }}</strong>
      </h2>
      <tw-list-group>
        <support-request-list-group-item v-for="supportRequest in supportRequests" :key="'support-request-message-key-' + supportRequest.id" :support-request="supportRequest" />
      </tw-list-group>
    </div>
  </tw-container>
</template>

<script>
import SupportRequestListGroupItem from '../../components/support-requests/support-request-list-group-item.vue'
import TwCard from '@/components/generic/tw-card.vue'
import { useSupportRequestsStore } from '@/stores/supportRequests.js'
import paginationWithStoreMixin from '@/mixins/paginationWithStoreMixin.js'
import TwContainer from '@/components/generic/tw-container.vue'
import TwDropdown from '@/components/generic/dropdown/tw-dropdown.vue'
import TwDropdownItem from '@/components/generic/dropdown/tw-dropdown-item.vue'
import TwListGroup from '@/components/generic/list-group/tw-list-group.vue'
import TwBadge from '@/components/generic/tw-badge.vue'
export default {
  name: 'SupportRequestsIndexPage',
  components: { TwBadge, TwListGroup, TwDropdownItem, TwDropdown, TwContainer, TwCard, SupportRequestListGroupItem },
  mixins: [paginationWithStoreMixin],
  props: {
    status: {
      type: String,
      default: 'all-currently-open'
    }
  },
  data () {
    return {
      LoadingFetchingSupportRequests: false
    }
  },
  computed: {
    itemsStoreModule() {
      return useSupportRequestsStore()
    },
    supportRequests () {
      return useSupportRequestsStore().getItems
    }
  },
  watch: {
    Page () {
      this.fetchSupportRequests()
    },
    status() {
      this.fetchSupportRequests()
    }
  },
  mounted () {
    this.fetchSupportRequests()
  },
  methods: {
    async fetchSupportRequests () {
      this.LoadingFetchingSupportRequests = true
      const data = await useSupportRequestsStore().fetchItems( {
        status: this.status,
        clear: true,
      })
      this.LoadingFetchingSupportRequests = false
      return data
    }
  }
}
</script>

<style scoped>

</style>
